"use strict";
exports.__esModule = true;
exports.calculateRemainingSeconds = exports.calculateRemainingMinutes = exports.calculateInitialTime = void 0;
var calculateInitialTime = function (_a) {
    var minutes = _a.minutes, seconds = _a.seconds;
    var initialMinutes = minutes * 60 * 1000;
    var initialSeconds = seconds * 1000;
    var initialTime = initialMinutes + initialSeconds;
    return initialTime;
};
exports.calculateInitialTime = calculateInitialTime;
var calculateRemainingMinutes = function (remainingTime) {
    return Math.floor(remainingTime / (60 * 1000));
};
exports.calculateRemainingMinutes = calculateRemainingMinutes;
var calculateRemainingSeconds = function (remainingTime) {
    return Math.floor((remainingTime / 1000) % 60);
};
exports.calculateRemainingSeconds = calculateRemainingSeconds;
//# sourceMappingURL=time.js.map